import SearchBar from "@design-system/Inputs/SearchBar";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { FilterChips } from "../../externalQuestionnaire/components/FilterChips";
import { keys, RESOURCE_NAME } from "../../i18n";
import { isQuestionnaireStatus } from "../../services";
import { type QuestionnaireStatus } from "../../types";
import { CreateQuestionnaireModal } from "../CreateQuestionnaireModal";
import { CreateQuestionnaireFromUploadModal } from "../QuestionnairesDashboard/CreateQuestionnaireFromUploadModal";

export const QuestionnaireTabHeader: FC<{
    searchString: string | undefined;
    setSearchString: (value: string | undefined) => void;
    questionnaireStatus: QuestionnaireStatus[];
    setQuestionnaireStatus: (value: QuestionnaireStatus[]) => void;
}> = ({
    searchString,
    setSearchString,
    questionnaireStatus,
    setQuestionnaireStatus,
}) => {
    const { t } = useTranslation(RESOURCE_NAME);

    const handleQuestionnaireStatusChange = (value: string[]) => {
        const statuses = value.filter((status) =>
            isQuestionnaireStatus(status),
        );
        setQuestionnaireStatus(statuses);
    };

    return (
        <FlexCol gap="3">
            <FlexRow>
                <FilterChips>
                    <FilterChips.QuestionnaireStatusFilterChip
                        value={questionnaireStatus}
                        onValueChange={handleQuestionnaireStatusChange}
                    />
                </FilterChips>
            </FlexRow>
            <FlexRow justifyContent="between">
                <SearchBar
                    placeholder={t(keys.search_bar_placeholder)}
                    searchString={searchString}
                    setSearchString={setSearchString}
                    className="w-[250px]"
                />
                <FlexRow gap="3">
                    <CreateQuestionnaireModal />
                    <CreateQuestionnaireFromUploadModal />
                </FlexRow>
            </FlexRow>
        </FlexCol>
    );
};
